
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { routerNames } from '@/common/js/const';

import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: routerNames.OrderInvoiceSuccess,
components: {
Group,
Cell,
CellBox,
XHeader,
Icon,
Box,
XButton,
},
data() {
return {
qrcode: '',
};
},
created() {},
activated() {},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {
closeWindow() {

if (____isWechatBrowser()) {
WeixinJSBridge.call('closeWindow');
} else if (____isAlipayBrowser()) {
AlipayJSBridge.call('closeWebview');
} else {
window.opener = null;
window.close();
}
},
},
};
